import { useState, useEffect } from 'react';

const DESKTOP_BREAKPOINT = 768; // matches $breakpoints "md"

export const useIsDesktop = (): boolean => {
	const [isDesktop, setIsDesktop] = useState<boolean>(() => {
		if (typeof window === 'undefined') return false;
		return window.innerWidth >= DESKTOP_BREAKPOINT;
	});

	useEffect(() => {
		const mediaQuery = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`);

		const handleChange = (e: MediaQueryListEvent) => setIsDesktop(e.matches);

		mediaQuery.addEventListener('change', handleChange);
		return () => mediaQuery.removeEventListener('change', handleChange);
	}, []);

	return isDesktop;
};
